import { Sprite } from "pixi.js";

/**
 * Sprite que ES DUEÑO de su textura (canvas propio de partículas/procedural):
 * al destruirse —por cualquier camino (factories con `children: true`,
 * teardown genérico, huérfano)— destruye también textura y source, así el
 * canvas y la subida a GPU no quedan vivos. Las texturas compartidas de
 * Assets nunca pasan por acá.
 */
export class OwnedTextureSprite extends Sprite {
  override destroy(options?: Parameters<Sprite["destroy"]>[0]): void {
    const base = typeof options === "boolean" ? { children: options } : (options ?? {});

    super.destroy({ ...base, texture: true, textureSource: true });
  }
}
